<ll-titulo>Categoría</ll-titulo>
<grupo-recursos-new [grupoRecursoTipoCategoriasString]="grupoRecursoTipoCategorias"></grupo-recursos-new>
